/** @return {number, string} */
const getItemsInComparator = state => {
  return state.itemsInComparator;
};


export default {
  getItemsInComparator,
};
